import pushEvent, {
  EVENT_VOTE_FORM_WIDGET_VOTE,
  EVENT_VOTE_FORM_WIDGET_SUBSCRIBE,
} from 'pushEvent';
import { setCookie } from 'utils/cookie';

import { CHANGE_ACTIVE_VOTE_OPTION, VOTE_COOKIE_NAME } from './constants';

export const submitVote = (question, answer) => () => {
  // gtm
  pushEvent(EVENT_VOTE_FORM_WIDGET_VOTE, { question, answer });
  setCookie(VOTE_COOKIE_NAME, true, { expires: 3600 });
};

export const submitVoteSubscription = (question) => () => {
  // gtm
  pushEvent(EVENT_VOTE_FORM_WIDGET_SUBSCRIBE, { question });
};

export const changeVoteOption = (optionId) => (dispatch) =>
  dispatch({
    type: CHANGE_ACTIVE_VOTE_OPTION,
    payload: {
      nextActiveOptionId: optionId,
    },
  });
